export default 'paidConsumerHomepage'
